import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { NoteV2Component } from "@root/router/component/note-v2/note-v2.component";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { isNil, isNumber } from "lodash";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalService } from "ng-zorro-antd/modal";
import getSymbolFromCurrency from "currency-symbol-map";

@Component({
  selector: "host-widget-fee-block",
  templateUrl: "./fee-block.component.html",
  styleUrls: ["./fee-block.component.scss"],
  preserveWhitespaces: false,
})
export class WidgetFeeBlockComponent implements OnInit {
  _orderDetail;
  @Input()
  get orderDetail() {
    return this._orderDetail;
  }
  set orderDetail(value) {
    if (value) {
      this._orderDetail = {
        ...value,
        paid_amount: Math.abs(value?.amount_items?.settlement_amount?.amount),
      };

      this.form.patchValue({
        house_fee: value?.amount_items?.house_fee?.amount,
        commission: value?.amount_items?.commission?.amount || 0,
        currency_type: value?.currency_type,
      });

      this.rate = (value?.fee_list?.find((item) => item.key === "Rates" || item.key === "房费") ?? value?.fee_list?.[0])
        ?.value;
      this.commission = (
        value?.fee_list?.find((item) => item.key === "Commission" || item.key === "佣金") ?? value?.fee_list?.[1]
      )?.value;

      this.income = value?.amount_items?.other_income?.amount;
      // if (isNumber(this.income)) {
      //   this.income = `${this.currencySymbol}${this.income}`;
      // }

      this.outcome = value?.amount_items?.expense?.amount;
      // if (isNumber(this.outcome)) {
      //   this.outcome = `${this.currencySymbol}${this.outcome}`;
      // }
    }
  }
  @Input() isEditing = false;
  @Output() onEdit = new EventEmitter();
  @Output() onCancelEdit = new EventEmitter();
  @Output() onCompleteEdit = new EventEmitter();
  @Output() onLockOrder = new EventEmitter();
  optionsOfCurrency = [];

  form: UntypedFormGroup = this.fb.group({
    currency_type: null,
    house_fee: null,
    commission: null,
  });

  // 房费
  rate = "";

  // 佣金
  commission = "";

  // 其他收入
  income = "";

  // 其他支出
  outcome = "";

  get isMultiHouseReservation() {
    return this.orderDetail?.reservation_order?.reservation_count > 1;
  }

  get currencyType() {
    return this.orderDetail?.currency_type;
  }

  get currencySymbol() {
    return getSymbolFromCurrency(this.orderDetail?.currency_type);
  }

  constructor(
    private fb: UntypedFormBuilder,
    private orderSrv: OrderV2Service,
    private t: TranslateService,
    private modal: NzModalService,
    private msg: NzMessageService,
  ) {}

  ngOnInit() {
    this.initCurrencyOptions();
  }

  private initCurrencyOptions() {
    this.orderSrv.getCurrency().subscribe((res) => {
      this.optionsOfCurrency = res?.data?.currency_list?.map((c) => ({ label: c, value: c }));
    });
  }

  onModifyFee() {
    const form = this.form.value;
    if (isNil(form.house_fee) || form.house_fee === "") {
      return;
    }

    const params = {
      reservation_code: this.orderDetail.code,
      ...form,
    };
    this.orderSrv.setModifyReservationAmount(params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.onCompleteEdit.emit();

        this.msg.success(this.t.t("success.save"));

        if (this.orderDetail.sync_lock === 0) {
          this.onLockOrder.emit();
          // this.displayLockOrderTip();
        }
      }
    });
  }

  @WritePermissionGurd("reservation_list")
  onKeepAccount() {
    const modal = this.modal.create({
      nzTitle: this.t.t("word.add_note"),
      nzContent: NoteV2Component,
      nzWidth: 900,
      nzFooter: null,
      nzComponentParams: {
        type: "create",
        scope: "order",
        orderCode: this.orderDetail.code,
        data: {
          currency_type: this.orderDetail.currency_type,
        },
        // currency: this.orderDetail.currency_type,
      },
    });
    modal.afterClose.subscribe((res) => {
      if (res && res.refresh === true) {
        this.onCompleteEdit.emit();
      }
    });
  }
}
